import { cn } from '../../lib/cn'
import { accentAlpha } from '../../lib/slug'

interface AccentGlowProps {
  color?: string
  className?: string
  intensity?: number
  'data-hero'?: string
}

/** Soft radial accent bloom used behind product bottles and section headers. */
export function AccentGlow({ color = '#159A3C', className, intensity = 0.5, ...rest }: AccentGlowProps) {
  return (
    <div
      aria-hidden="true"
      className={cn('pointer-events-none absolute rounded-full blur-3xl', className)}
      style={{
        background: `radial-gradient(circle, ${accentAlpha(color, intensity)} 0%, ${accentAlpha(color, 0)} 70%)`,
      }}
      {...rest}
    />
  )
}
